import React from "react";
import heroImage from "../assets/Images/hero-8.jpg";
import { Box, Container, Typography } from "@mui/material";

export default function SecureChecksSection() {
  return (
    <Box
      sx={{
        borderTop: "4px solid #c6db8c",
        position: "relative",
        borderBottom: "4px solid #c6db8c",
        height: { xs: "auto", md: "80vh" },
        backgroundImage: `url(${heroImage})`, // اپنی image کا path دیں
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: { xs: "60px 20px", md: "0" },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "black",
          opacity: 0.3,
          zIndex: 0,
        }}
      />
      <Container maxWidth="lg" sx={{ color: "white", zIndex: 1 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            mb: 3,
            textAlign: "center",
          }}
        >
          DELIVERING SECURE CHECKS THROUGH CUTTING EDGE TECHNOLOGY
        </Typography>

        {/* Paragraph 1 */}
        <Typography
          variant="body1"
          sx={{ mb: 4, textAlign: "center", maxWidth: "900px", mx: "auto" }}
        >
          Safe Place is a private security and background investigation company
          that works with a network of partners to deliver world-class
          employment risk mitigation strategies. Alpha Check is the first of its
          kind in Nigeria, offering a combination of services at the fingertips
          of our users.
        </Typography>

        {/* Sub-heading */}
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            mb: 3,
            textAlign: "center",
          }}
        >
          OUR INFORMATION IS PROTECTED
        </Typography>

        {/* Paragraph 2 */}
        <Typography
          variant="body1"
          sx={{ mb: 4, textAlign: "center", maxWidth: "900px", mx: "auto" }}
        >
          Safe Place is a private security and background investigation company
          that works with a network of partners to deliver world-class
          employment risk mitigation strategies. Alpha Check is the first of its
          kind in Nigeria, offering a combination of services at the fingertips
          of our users. Safe Place is owned by a UK based company, Alpha Group
          Ltd.
        </Typography>

        {/* Who this service is for */}
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            mb: 2,
            textAlign: "center",
          }}
        >
          Who this service is for:
        </Typography>

        <Box sx={{ textAlign: "center" }}>
          <Typography>Government Agencies</Typography>
          <Typography>
            Employers (Recruitment, Promotion & Third Party Contractors)
          </Typography>
          <Typography>
            Country Mission Offices (for Visas/Entry Clearances)
          </Typography>
          <Typography>Political Parties (for Appointees & Nominees)</Typography>
        </Box>
      </Container>
    </Box>
  );
}
